import { Tag } from 'ui';
import { KoobTooltip } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { upperCase } from 'lodash';

const getVariantDependingOnState = (state) => {
  const variantByState = {
    gray: ['draft'],
    blue: ['sent'],
    primary: ['pending', 'pending_source'],
    green: ['confirmed'],
    red: ['refused', 'canceled'],
    purple: ['pre_confirmed'],
    black: ['replaced'],
  };

  for (const variant in variantByState) {
    if (variantByState[variant].includes(state)) {
      return { variant, state };
    }
  }
  return { variant: 'primary', state };
};

const BookingState = ({
  state,
  canceledBy,
  translationKey,
  disabled,
  isExperience = false,
  ...props
}) => {
  const theme = useTheme();
  const { t } = useTranslation(translationKey);
  const tagInfo = getVariantDependingOnState(state);

  return (
    <KoobTooltip
      tip={
        !canceledBy
          ? t(`tooltip.${state}`, { name: isExperience ? 'Dmc' : 'Hotel' })
          : t('tooltip.canceledBy', { name: upperCase(canceledBy) })
      }
      color="purple"
      hasArrow={false}
      position="left"
      disabled={disabled}
      {...props}
    >
      <Tag variant={tagInfo.variant}>
        {state === 'pending' && (
          <i
            className="fa-light fa-triangle-exclamation"
            style={{ fontSize: 16, color: theme.primary }}
          />
        )}
        {t(tagInfo.state)}
      </Tag>
    </KoobTooltip>
  );
};

export default BookingState;
